import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const stacked = definePartsStyle({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '1.5',
    fontFamily: 'heading',
    fontWeight: '400',
    textTransform: 'uppercase',
  },
  label: {
    ml: 0,
    mt: 1,
    lineHeight: '1',
  },
});

export default defineMultiStyleConfig({
  baseStyle: {
    // container: {
    // },
    track: {
      bg: 'gray.200',
      _checked: {
        bg: 'linkColor',
      },
      _dark: {
        bg: 'gray.700',
        _checked: {
          bg: 'linkColor',
        },
      },
    },
    thumb: {
      bg: 'white',
    },
  },
  sizes: {
    lg: {
      track: {
        w: 10,
        h: 5,
        p: 0.5,
      },
      thumb: {
        w: 5,
        h: 5,
        _checked: {
          transform:
            'translate(calc(var(--chakra-sizes-10) - var(--chakra-sizes-5)))',
        },
      },
    },
  },
  variants: {
    stacked,
  },
});
